import React, { FC } from "react";
import s from "./ActionButton.module.scss";

export interface ActionButtonProps {
  id: string;
  icon?: React.ReactNode;
  label?: string;
  isActive?: boolean;
  onClick: () => void;
  disabled?: boolean;
  "data-tour"?: string;
}

export const ActionButton: FC<ActionButtonProps> = ({
  id,
  icon,
  label,
  isActive = false,
  onClick,
  disabled = false,
  ...rest
}) => {
  return (
    <button
      id={id}
      type="button"
      onClick={onClick}
      className={`${s.btn} ${disabled ? s.disabled : ""} ${isActive ? s.active : ""}`}
      disabled={disabled}
      {...rest}
    >
      {icon && <span className={s.icon}>{icon}</span>}
    </button>
  );
};
